import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const ProcesarMovimiento = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.post(`/administracion-inventario/movimientos/data/procesar/validacion/continuo`, params, {
            dataType: "json",
            hasFormData: false,
            hasCustomUrl: false,
        });
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        procesarMovimientoMutation: mutation.mutate,
    };
}